module.exports = __webpack_public_path__ + "img/liugey.8f9f7774.png";